interface Props {
  sortOrder: number | null;
  onChange: (next: number | null) => void;
}

/**
 * Sort order panel — controls where this FAQ sits on the public
 * /faq page. Lower numbers appear first; blank/zero leaves it
 * un-ordered (sorts to the bottom).
 */
export function SortOrderPanel({ sortOrder, onChange }: Props) {
  return (
    <div className="shadow-card rounded-lg bg-paper-hi">
      <div className="hair-b border-b px-4 py-3">
        <h3 className="text-[13px] font-semibold">Sort order</h3>
      </div>
      <div className="p-4">
        <input
          type="number"
          value={sortOrder ?? ""}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === "") {
              onChange(null);
              return;
            }
            const parsed = parseInt(raw, 10);
            onChange(Number.isNaN(parsed) ? null : parsed);
          }}
          placeholder="—"
          min={0}
          step={1}
          className="hair num w-full rounded-md border bg-paper px-2.5 py-1.5 text-[12.5px] text-ink-2 focus:border-tide focus:outline-none"
        />
        <p className="mt-1.5 text-[11px] text-ink-5">
          Lower numbers appear first on /faq. Leave blank to sort to the
          bottom.
        </p>
      </div>
    </div>
  );
}
